/**
 * Configuration du cabinet : marque et règles métier.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * POURQUOI CE FICHIER
 *
 * Ce CRM a été écrit pour CB Courtage, et son nom, son logo, sa couleur et ses
 * règles de calcul étaient dispersés dans quatorze endroits du code. Les
 * installer chez un autre courtier aurait voulu dire modifier le code, donc
 * maintenir une version par client — la manière la plus sûre de finir avec
 * cinq logiciels différents à corriger cinq fois.
 *
 * Tout ce qui distingue un cabinet d'un autre est désormais ICI, et nulle part
 * ailleurs. Installer chez un nouveau client revient à modifier ce fichier,
 * remplacer le logo, et redéployer.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * UNE INSTALLATION PAR CLIENT
 *
 * Chaque cabinet a son serveur, sa base et ses sauvegardes. Les données d'un
 * courtier ne côtoient jamais celles d'un autre : c'est garanti par
 * l'architecture, pas par du code de filtrage qu'il faudrait auditer.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * ÉTAPE SUIVANTE, QUAND IL Y AURA PLUSIEURS CLIENTS
 *
 * Déplacer ces valeurs en base, avec un écran de réglages dans Administration.
 * Le cabinet changerait alors son logo ou son objectif lui-même, sans
 * développeur ni redéploiement. Ce fichier deviendrait les valeurs par défaut.
 * Tant qu'il n'y a qu'un client, ce serait du travail en avance.
 */

import logo from './logo-cb-courtage.png';

export const MARQUE = {
  // Nom affiché dans le menu, l'écran de connexion, l'assistant et les
  // identifiants remis aux clients.
  nom: 'CB Courtage',

  // Baseline sous le nom, dans le menu. Laisser vide pour ne rien afficher.
  activite: 'Crédit & Assurance',

  // Logo : remplacer le fichier importé ci-dessus.
  logo,

  // Adresse à laquelle les clients se connectent, communiquée dans les
  // identifiants de l'espace client.
  urlPubliqueCRM: 'https://crm.cbcourtage.fr',

  // Couleur d'accent. Reprise par src/theme.js pour tout le CRM : la changer
  // ici suffit à rhabiller l'application entière.
  couleurAccent: '#1a2b4a',
};

/**
 * Règles de calcul propres au cabinet.
 *
 * Elles étaient écrites en dur dans le tableau de bord. Un courtier qui vise
 * 25 affaires, considère qu'une échéance devient urgente à 90 jours ou prend
 * 15 % de commission n'a aucune raison de vivre avec les chiffres de
 * CB Courtage.
 */
export const REGLES = {
  // Objectif d'affaires gagnées sur la période, pour la jauge du tableau de bord.
  objectifAffairesGagnees: 10,

  // En deçà de ce délai, une échéance est signalée comme « affaire chaude ».
  joursAffaireChaude: 120,

  // Part de la prime d'assurance revenant au cabinet (0.1 = 10 %).
  partCabinetSurPrime: 0.1,

  // Taux de transformation constaté, pour en déduire le nombre de besoins à
  // détecter afin d'atteindre l'objectif (0.2 = une affaire gagnée sur cinq).
  tauxTransformation: 0.2,

  // Nombre de visites nécessaires en moyenne pour détecter un besoin.
  visitesParBesoin: 6,
};
